import { createSlice } from '@reduxjs/toolkit';

import { DOCTOR_NAMES_KEY } from 'utilities/storageKeys';

import { get } from 'temp/utilities/storage';

export const doctorDetails = createSlice({
    name: 'doctorDetails',

    initialState: {
        doctorModal: false,
        isApiFailed: false,
        doctorNames: get(DOCTOR_NAMES_KEY, [])
    },

    reducers: {
        setDoctorModal: (state, action) => {
            state.doctorModal = action.payload;
        },

        setDoctorNames: (state, action) => {
            state.doctorNames = action.payload;
        },
        setIsApiFailed: (state, action) => {
            state.isApiFailed = action.payload;
        }
    }
});

export const { setDoctorModal, setDoctorNames, setIsApiFailed } =
    doctorDetails.actions;

export default doctorDetails.reducer;
